import React, { useEffect } from "react";
import Footer from "../../components/Footer/Footer";
import { Helmet } from "react-helmet";
import PrivacyPage from "./components/PrivacyPage";
import DoNotSellOrShare from "./components/DoNotSellOrShare";
import BeefEventTerms from "./components/BeefEventTerms";

export default function StaticPage({ pageTitle, pageSlug }) {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pageSlug]);

  return (
    <>
      <div
        className="page-container"
        style={{
          background: `linear-gradient(
            to right,
            rgba(229, 9, 20,0.2) 0%,
            rgba(0,0,0,.5) 50%,
            rgba(229, 9, 20,0.2) 100%
          )`,
        }}
      >
        <Helmet>
          <title>{`${pageTitle} | Netflix Series FYC`}</title>
          <meta
            name="description"
            content={`${pageTitle} | Netflix Series FYC`}
          />
        </Helmet>

        <div className="page-content px-3" style={{ paddingTop: "0px" }}>
          {/*<div className="page-divider" />*/}
          <div className="width-ctrl">
            {pageSlug === "privacy" ? (
              <PrivacyPage pageTitle={pageTitle} />
            ) : (
              <></>
            )}
            {pageSlug === "do-not-sell-or-share" ? (
              <DoNotSellOrShare pageTitle={pageTitle} />
            ) : (
              <></>
            )}
            {pageSlug === "beef-event-terms" ? (
              <BeefEventTerms pageTitle={pageTitle} />
            ) : (
              <></>
            )}
          </div>
        </div>

        <Footer type={"page"} />
      </div>
    </>
  );
}
